import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll() {
    return await requestWrapper(null, 'GET', `/implementators`);
  },
  async create(implementator) {
    return await requestWrapper(null, 'POST', '/implementators', null, implementator);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/implementators/${id}`);
  },
  async update(implementator) {
    return await requestWrapper(null, 'PUT', `/implementators/${implementator.id}`, null, implementator);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/implementators/${id}`);
  },
};
